import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utm } from '@banyan/commons/models/utm.models';
import { AccountService } from '@banyan/modules/account/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class UtmService {
  utmParams: Utm = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_id: '',
    utm_content: '',
  };
  accountService = inject(AccountService);

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.setUtmParams();
  }

  setUtmParams() {
    this.router.events.subscribe(() => {
      this.route.queryParams.subscribe(params => {
        const hasUtmParams =
          params['utm_source'] ||
          params['utm_medium'] ||
          params['utm_campaign'] ||
          params['utm_id'] ||
          params['utm_content'];

        if (hasUtmParams) {
          this.utmParams = {
            ...this.utmParams,
            utm_source: params['utm_source'] || '',
            utm_medium: params['utm_medium'] || '',
            utm_campaign: params['utm_campaign'] || '',
            utm_id: params['utm_id'] || '',
            utm_content: params['utm_content'] || '',
          };
          this.accountService.user.update(user => ({ ...user, utm: this.utmParams }));
        }
      });
    });
  }
}
